import { useEffect, useState } from "react";
import axios from "../axiosInstance";

export default function Register({ close, refresh }) {
    const API = process.env.REACT_APP_API_URL;

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [department, setDepartment] = useState("");
    const [departments, setDepartments] = useState([]);
    const [branch, setBranch] = useState("");
    const [branches, setBranches] = useState([]);
    const [role, setRole] = useState("");

    const selectedrole = [
        { name: "Client", value: "client" },
        { name: "Support", value: "support" },
        { name: "Admin", value: "admin" },
    ];

    // -----------------------------
    // REGISTER USER
    // -----------------------------
    const handleregister = async () => {
        try {
            if (!username || !password || (role === "support" && !department) || !branch || !role) {
                alert("Please fill all details");
                return;
            }

            const res = await axios.post(`${API}/api/register/`, {
                username,
                password,
                department,
                branch_id: branch,
                role,
            });

            alert("User Registered Successfully: " + res.data.role);

            clear();
            refresh();
            close();

        } catch (error) {
            console.error("Registration error:", error);

            alert(
                error?.response?.data?.error ||
                error?.response?.data?.detail ||
                error?.response?.data?.message ||
                "Unable to register user"
            );
        }
    };

    // -----------------------------
    // FETCH DEPARTMENTS
    // -----------------------------

    // -----------------------------
    // FETCH BRANCHES
    // -----------------------------
    const fetchbranches = async () => {
        try {
            const res = await axios.get(`${API}/api/get/branches/`);
            setBranches(res.data);
        } catch (error) {
            console.error("Error fetching branches:", error);
        }
    };

    useEffect(() => {
        fetchbranches();
    }, []);

    useEffect(() => {
        let active = true;
        setDepartment("");
        setDepartments([]);
        if (branch) {
            axios.get(`${API}/api/get/dep/`, { params: { branch_id: branch } })
                .then((res) => { if (active) setDepartments(res.data || []); })
                .catch(() => { if (active) alert("Unable to load departments for this location."); });
        }
        return () => { active = false; };
    }, [API, branch]);

    // -----------------------------
    // CLEAR FORM
    // -----------------------------
    const clear = () => {
        setUsername("");
        setPassword("");
        setDepartment("");
        setBranch("");
        setRole("");
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 py-6">

            {/* Modal */}
            <div
                className="
                    relative
                    w-full
                    max-w-md
                    max-h-[95vh]
                    overflow-y-auto
                    rounded-2xl
                    bg-white
                    shadow-2xl
                "
            >

                {/* ================= HEADER ================= */}
                <div className="border-b border-slate-200 px-5 py-4 sm:px-6">

                    <div className="flex items-start justify-between">

                        <div className="flex items-center gap-3">

                            {/* Icon */}
                            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-blue-600">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-7a4 4 0 11-8 0 4 4 0 018 0zM4 20a8 8 0 1116 0H4z"
                                    />
                                </svg>
                            </div>

                            <div>
                                <h2 className="text-lg font-bold text-slate-900 sm:text-xl">
                                    Create User
                                </h2>

                                <p className="text-xs text-slate-500 sm:text-sm">
                                    Add a new user to the system
                                </p>
                            </div>

                        </div>

                        {/* Close Button */}
                        <button
                            type="button"
                            onClick={close}
                            className="
                                flex
                                h-8
                                w-8
                                items-center
                                justify-center
                                rounded-lg
                                text-slate-400
                                transition
                                hover:bg-slate-100
                                hover:text-slate-700
                            "
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>

                    </div>
                </div>

                {/* ================= FORM ================= */}
                <div className="space-y-5 px-5 py-5 sm:px-6">

                    {/* Username */}
                    <div>
                        <label className="mb-1.5 block text-sm font-medium text-slate-700">
                            Username <span className="text-red-500">*</span>
                        </label>

                        <div className="relative">

                            <input
                                type="text"
                                value={username}
                                placeholder="Enter username"
                                onChange={(e) => setUsername(e.target.value)}
                                className="
                                    h-11
                                    w-full
                                    rounded-lg
                                    border
                                    border-slate-300
                                    bg-white
                                    px-3
                                    text-sm
                                    text-slate-900
                                    outline-none
                                    transition
                                    placeholder:text-slate-400
                                    focus:border-blue-500
                                    focus:ring-2
                                    focus:ring-blue-100
                                "
                            />

                        </div>
                    </div>

                    {/* Password */}
                    <div>
                        <label className="mb-1.5 block text-sm font-medium text-slate-700">
                            Password <span className="text-red-500">*</span>
                        </label>

                        <input
                            type="password"
                            value={password}
                            placeholder="Enter password"
                            onChange={(e) => setPassword(e.target.value)}
                            className="
                                h-11
                                w-full
                                rounded-lg
                                border
                                border-slate-300
                                bg-white
                                px-3
                                text-sm
                                text-slate-900
                                outline-none
                                transition
                                placeholder:text-slate-400
                                focus:border-blue-500
                                focus:ring-2
                                focus:ring-blue-100
                            "
                        />
                    </div>

                    {/* Department + Branch */}
                    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">

                        {/* Department */}
                        <div>
                            <label className="mb-1.5 block text-sm font-medium text-slate-700">
                                Department <span className="text-red-500">*</span>
                            </label>

                            <select
                                value={department}
                                onChange={(e) => setDepartment(e.target.value)}
                                className="
                                    h-11
                                    w-full
                                    rounded-lg
                                    border
                                    border-slate-300
                                    bg-white
                                    px-3
                                    text-sm
                                    text-slate-700
                                    outline-none
                                    transition
                                    focus:border-blue-500
                                    focus:ring-2
                                    focus:ring-blue-100
                                "
                            >
                                <option value="">
                                    Select department
                                </option>

                                {departments.map((dept) => (
                                    <option
                                        key={dept.id}
                                        value={dept.name}
                                    >
                                        {dept.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Branch */}
                        <div>
                            <label className="mb-1.5 block text-sm font-medium text-slate-700">
                                Branch <span className="text-red-500">*</span>
                            </label>

                            <select
                                value={branch}
                                onChange={(e) => setBranch(e.target.value)}
                                className="
                                    h-11
                                    w-full
                                    rounded-lg
                                    border
                                    border-slate-300
                                    bg-white
                                    px-3
                                    text-sm
                                    text-slate-700
                                    outline-none
                                    transition
                                    focus:border-blue-500
                                    focus:ring-2
                                    focus:ring-blue-100
                                "
                            >
                                <option value="">
                                    Select branch
                                </option>

                                {branches.map((item) => (
                                    <option
                                        key={item.id}
                                        value={item.id}
                                    >
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                    </div>

                    {/* Role */}
                    <div>
                        <label className="mb-1.5 block text-sm font-medium text-slate-700">
                            User Role <span className="text-red-500">*</span>
                        </label>

                        <select
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            className="
                                h-11
                                w-full
                                rounded-lg
                                border
                                border-slate-300
                                bg-white
                                px-3
                                text-sm
                                text-slate-700
                                outline-none
                                transition
                                focus:border-blue-500
                                focus:ring-2
                                focus:ring-blue-100
                            "
                        >
                            <option value="">
                                Select role
                            </option>

                            {selectedrole.map((item) => (
                                <option
                                    key={item.value}
                                    value={item.value}
                                >
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>

                </div>

                {/* ================= FOOTER ================= */}
                <div className="flex flex-col-reverse gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4 sm:flex-row sm:justify-end sm:px-6">

                    <button
                        type="button"
                        onClick={close}
                        className="
                            h-10
                            rounded-lg
                            border
                            border-slate-300
                            bg-white
                            px-5
                            text-sm
                            font-medium
                            text-slate-700
                            transition
                            hover:bg-slate-100
                        "
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        onClick={handleregister}
                        className="
                            h-10
                            rounded-lg
                            bg-blue-600
                            px-5
                            text-sm
                            font-semibold
                            text-white
                            shadow-sm
                            transition
                            hover:bg-blue-700
                            focus:outline-none
                            focus:ring-2
                            focus:ring-blue-500
                            focus:ring-offset-2
                        "
                    >
                        Create User
                    </button>

                </div>

            </div>
        </div>
    );
}
